module.exports = __webpack_public_path__ + "img/partner11.9f83fff3.png";